const CAROUSEL_ITEMS = [
  {
    title: '夏季剧场 · 独家热播',
    subtitle: '多部国产大剧同步上线，每日更新不重样',
    tag: '正在热播',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20summer%20theater%20promotional%20banner%20with%20warm%20golden%20sunset%20cinematic%20lighting%2C%20multiple%20overlapping%20film%20frames%20with%20drama%20scenes%2C%20dark%20elegant%20background%20with%20subtle%20sparkle%20effects%2C%20premium%20entertainment%20marketing%20aesthetic%2C%20rich%20contrast%20and%20depth&width=1200&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '4K蓝光专区 · 视觉盛宴',
    subtitle: '全平台超清画质升级，200+部蓝光资源全新上架',
    tag: '画质升级',
    cover: 'https://readdy.ai/api/search-image?query=A%20luxurious%20home%20cinema%20setup%20with%20a%20large%20modern%20TV%20screen%20displaying%20vibrant%20cinematic%20content%2C%20soft%20amber%20ambient%20lighting%20in%20a%20dark%20room%2C%20premium%20entertainment%20technology%20aesthetic%2C%20clean%20minimal%20interior%20design%2C%20cinematic%20atmosphere&width=1200&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '动漫新番 · 同步追更',
    subtitle: '《鬼灭之刃》《咒术回战》等热门日漫与日本同步更新',
    tag: '新番连载',
    cover: 'https://readdy.ai/api/search-image?query=An%20anime%20promotional%20banner%20featuring%20multiple%20popular%20anime%20characters%20in%20dynamic%20action%20poses%2C%20warm%20orange%20and%20gold%20fire%20lighting%20effects%2C%20dark%20dramatic%20background%2C%20stylized%20Japanese%20animation%20aesthetic%2C%20vibrant%20energy%20and%20intense%20mood&width=1200&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '电影大全 · 院线同步',
    subtitle: '国内外院线大片下线后第一时间上线蓝光版本',
    tag: '影院品质',
    cover: 'https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20marathon%20promotional%20banner%20with%20film%20reels%20and%20movie%20poster%20collage%20in%20warm%20golden%20lighting%2C%20classic%20cinema%20atmosphere%2C%20dark%20elegant%20background%2C%20vintage%20theater%20aesthetic%20mixed%20with%20modern%20design%2C%20rich%20texture%20and%20depth&width=1200&height=500&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-50">
            焦点专题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            本周精选专题内容，发现更多精彩
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {CAROUSEL_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="group relative rounded-xl overflow-hidden bg-background-100 border border-background-300/15 hover:border-background-300/30 transition-all cursor-pointer"
            >
              <div className="relative aspect-[2.4/1] overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.currentTarget as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-background-950/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <span className="inline-block px-2.5 py-1 text-xs font-medium rounded-full bg-primary-500/80 text-background-950 mb-2 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-50">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-sm text-foreground-300">
                    {item.subtitle}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}